import { neuralnetworks } from '@mentimeter/sfinx-themes';

export const NeuralNetworksBackground = neuralnetworks.background;
